export const AUTHENTICATE_ERROR = 'app/AUTHENTICATE_ERROR';
export const SIGN_OUT = 'app/SIGN_OUT';
export const OPEN_MENU_ITEM = 'app/OPEN_MENU_ITEM';
export const STORE_LOGIN_ITEMS = 'app/STORE_LOGIN_ITEMS';
export const SET_ACTIVE_BRANCH = 'app/SET_ACTIVE_BRANCH';
export const START_LOADING = 'app/START_LOADING';
export const STOP_LOADING = 'app/STOP_LOADING';
export const STORE_ADMIN_SELECTED_BRANCHES = 'STORE_ADMIN_SELECTED_BRANCHES';
export const UPDATE_APP_CONFIG = 'UPDATE_APP_CONFIG';
